<template>
  <form class="tools-partners-profile-modal p-5" @submit.prevent="submit">
    <div class="d-flex justify-content-between modal-title mb-5">
      Adicionar perfil de colaborador
      <button class="btn btn-sm" @click="$emit('close')">
        <i class="fa fa-close fs-16" />
      </button>
    </div>

    <form-group
      v-model="form.name"
      required
      label="Nome do perfil"
      id="name"
      placeholder="Digite o nome do perfil"
      :errors="errors.name"
    />
    <div class="d-flex justify-content-end mb-5">
      <small
        class="text-secondary"
        :class="{
          'text-danger': form.name && form.name.length > 64
        }"
      >
        {{ `${form.name ? form.name.length : 0}/64` }}
      </small>
    </div>

    <h5 class="modal-title mt-5">Permissões</h5>
    <div class="modal-description mb-5">
      Determine quais permissões esse perfil terá
    </div>

    <div class="row">
      <div
        v-for="category in permissions"
        :key="category.code"
        class="col-lg-6 mb-5"
      >
        <checkboxes-dropdown
          v-model="filteredCategories[category.name]"
          placeholder="Selecione as permissões desejadas"
          :id="`form-permissions-${category.name}`"
          :label="category.name"
          :options="
            category.permissions.map(({ code, name }) => ({ id: code, name }))
          "
        />
      </div>
    </div>

    <div class="d-flex flex-column flex-lg-row justify-content-end mt-3">
      <button
        type="button"
        class="btn btn-new-secondary order-1 order-lg-0 mr-lg-5"
        @click="$emit('close')"
      >
        Cancelar
      </button>
      <button
        class="btn btn-primary order-0 order-lg-1 mb-5 mb-lg-0"
        type="submit"
        :disabled="!isValid"
      >
        <loading :show="loading">
          Salvar
        </loading>
      </button>
    </div>
  </form>
</template>

<script>
import { formFields, updateArrayItem } from "@/functions/helpers.js";
import { mapState } from "vuex";

export default {
  props: {
    item: Object
  },
  data() {
    const item = this.item || {};
    return {
      ...formFields(["name", "scope"], { scope: [], ...item })
    };
  },
  computed: {
    ...mapState("partnersCenter", ["permissions", "profiles"]),
    isValid() {
      return this.form.name && this.form.name.length <= 64;
    },
    filteredCategories() {
      let options = {};
      this.permissions.forEach(
        category =>
          (options[category.name] = this.form.scope.filter(scope =>
            category.permissions.map(p => p.code).includes(scope)
          ))
      );
      return options;
    }
  },
  methods: {
    submit() {
      const data = {
        ...this.form,
        scope: Object.values(this.filteredCategories).flat()
      };
      data.scope = data.scope.reduce((prev, cur) => {
        const obj = { ...prev };
        obj[cur] = ["read", "update", "write", "delete"];
        return obj;
      }, {});

      let action = "partnersCenter/postProfile";
      if (this.item) {
        action = "partnersCenter/putProfile";
        data.id = this.item.id;
      }

      this.loading = true;
      this.$store
        .dispatch(action, data)
        .then(({ data }) => {
          this.$message.success(
            this.item ? "Colaborador editado" : "Convite enviado"
          );
          this.$emit("close");

          this.item
            ? this.$store.commit(
                "partnersCenter/setProfiles",
                updateArrayItem(this.profiles, data)
              )
            : this.$emit("reload");
        })
        .catch(error => {
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
